// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(245, 245, 245, 0.7411764706);
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-container .loading-clock {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.loading-container .circle {
  width: 8px;
  height: 8px;
  margin-right: 4px;
  border-radius: 50%;
  background-color: #2196f3;
  opacity: 0.2;
  transition: opacity 0.2s ease-in-out;
}
.loading-container .circle.loaded {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/LoadingClock/LoadingClock.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,mDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACD;AACC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AACF;AAEC;EACC,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,oCAAA;AAAF;AAGC;EACC,UAAA;AADF","sourcesContent":[".loading-container {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100vw;\n\theight: 100vh;\n\tbackground-color: #f5f5f5bd;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t.loading-clock {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\theight: 100%;\n\t}\n\n\t.circle {\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tmargin-right: 4px;\n\t\tborder-radius: 50%;\n\t\tbackground-color: #2196f3;\n\t\topacity: 0.2;\n\t\ttransition: opacity 0.2s ease-in-out;\n\t}\n\n\t.circle.loaded {\n\t\topacity: 1;\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
